import { EverGivePercentageContribution, useCheckoutPlan } from '@shamaazi/mytennights'
import { type FC, useState } from 'react'

const defaultPercentages = [0, 25, 50, 100]

export const EverGivePercentageInput: FC = () => {
  const { plan, setPlan } = useCheckoutPlan()
  const [error, setError] = useState<string>('')

  const setPlanEverGivePercentage = (percentage: number | null, optIn: boolean): void => {
    setPlan({ ...plan, evergiveSharePercentage: percentage, egContributionOptIn: optIn })
  }

  return <div>
    <EverGivePercentageContribution egError={error} setEgError={setError} defaultPercentages={defaultPercentages} planEverGivePercentage={plan.evergiveSharePercentage} setPlanEverGivePercentage={setPlanEverGivePercentage} />
  </div>
}
